var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71943 8.92963C5.01232 8.63674 5.48719 8.63674 5.78009 8.92963L12.4998 15.6493L19.2194 8.92963C19.5123 8.63674 19.9872 8.63674 20.2801 8.92963C20.573 9.22252 20.573 9.6974 20.2801 9.99029L13.0301 17.2403C12.7372 17.5332 12.2623 17.5332 11.9694 17.2403L4.71943 9.99029C4.42653 9.6974 4.42653 9.22252 4.71943 8.92963Z",
    fill: "#BEC1C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.da555f6eea43c8429aa4043c8eb2acd2.svg";
export { ForwardRef as ReactComponent };